<template>
  <div class="sidebar xs-12 m-4 dea-bg-grey-light">
    <slot />
    <div class="sidebar__links-container">
      <div v-if="config.states.StartOrEndedRegistration.indexOf(order.state) > -1">
        <Links
          class="dea-links--large dea-links--generic-dark-grey"
          role="button"
          tabindex="0"
          @click="returnToStart()"
          @keydown.enter="returnToStart()"
          >Modifica dettagli</Links
        >
      </div>
      <div v-if="linkBackObject">
        <Links :href="linkBackObject.url" class="dea-links--large dea-links--generic-dark-grey">{{
          linkBackObject.label
        }}</Links>
      </div>
      <div v-if="$route && backEnabledRoutes.indexOf($route.name) > -1">
        <router-link :to="{ name: 'events', params: { ticketFilter: 'past', updateRegistrations: true } }"
          ><Links class="dea-links--large dea-links--generic-dark-grey">Torna ai corsi</Links></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Links from "@/components/elements/Links";

export default {
  name: "Sidebar",
  components: {
    Links,
  },
  props: {
    linkBackObject: {
      type: Object,
      default: () => {},
    },
    backEnabledRoutes: {
      type: Array,
      default: () => {
        return ["download", "personal-data", "survey", "certificate", "registration"];
      },
    },
  },
  computed: {
    ...mapGetters(["order", "config", "user"]),
  },
  methods: {
    ...mapActions(["resetConfirmationData"]),
    returnToStart() {
      this.resetConfirmationData();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.sidebar {
  @include media("<=s") {
    margin-top: $space-small;
    min-height: auto;
    padding: $space-small;
  }
  min-height: 80vh;
  padding: $space-base;

  &__links-container {
    & > div:first-child {
      margin: $space-small 0;
    }

    & > div:last-child {
      @include media("<=s") {
        margin-bottom: 0;
      }
      margin-bottom: $space-small;
    }
  }
}
</style>
